import { render, staticRenderFns } from "./PrefPicker.vue?vue&type=template&id=5f64264e&scoped=true&"
import script from "./PrefPicker.vue?vue&type=script&lang=js&"
export * from "./PrefPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f64264e",
  null
  
)

export default component.exports